import * as React from 'react';
import { BodyMediumEmphasized, Icon, PlusIcon, View, XStack } from 'smoothie';

interface AddRuleButtonProps {
    onPress: () => void;
}

const AddRuleButton = ({ onPress }: AddRuleButtonProps) => {
    return (
        <XStack
            gap={8}
            onPress={onPress}
            alignItems="center"
            animation="button"
            pressStyle={{ scale: 0.95 }}
        >
            <View
                padding={15}
                borderRadius={12}
                borderWidth={1}
                borderColor="$gray800"
            >
                <Icon icon={PlusIcon} size={20} />
            </View>
            <BodyMediumEmphasized>Add rule</BodyMediumEmphasized>
        </XStack>
    );
};

export default AddRuleButton;
